module.exports = __webpack_public_path__ + "media/song-sparrow-1.b6d21737.mp3";